/**
 * Featured Locations section
 * ------------------------------------------------------------------------------
 * Manages featured/all toggle state and lazy-loads the Stockist map widget.
 */

const STOCKIST_WIDGET_SRC = "https://stockist.co/embed/v1/widget.min.js";
const STOCKIST_WIDGET_SCRIPT_ID = "featured-locations-map-script";

class FeaturedLocationsSection extends HTMLElement {
  connectedCallback() {
    if (this.__isInitialized) {
      return;
    }

    this.__isInitialized = true;

    const sectionId = this.dataset.featuredLocationsSection || "";
    this.__featuredTab = this.querySelector(`#featured-locations-featured-${sectionId}`);
    this.__allTab = this.querySelector(`#featured-locations-all-${sectionId}`);
    this.__featuredPanel = this.querySelector(".featured-locations__panel--featured");
    this.__allPanel = this.querySelector(".featured-locations__panel--all");
    this.__mapContainer = this.querySelector("[data-featured-locations-map-container]");
    this.__mapPlaceholder = this.querySelector("[data-featured-locations-map-placeholder]");
    this.__tabs = this.querySelector(".featured-locations__tabs");
    this.__mapIsInitialized = false;

    if (
      !this.__featuredTab ||
      !this.__allTab ||
      !this.__featuredPanel ||
      !this.__allPanel ||
      !this.__tabs ||
      !this.__mapContainer
    ) {
      return;
    }

    this.__featuredTabBtn = this.__tabs.querySelector(".featured-locations__tab-btn--featured");
    this.__allTabBtn = this.__tabs.querySelector(".featured-locations__tab-btn--all");

    this.__handleFeaturedChange = this.setActiveTab.bind(this, "featured");
    this.__handleAllChange = this.handleAllChange.bind(this);

    this.setActiveTab(this.__allTab.checked ? "all" : "featured");

    if (this.__allTab.checked) {
      this.loadMapWidget();
      return;
    }

    this.__featuredTab.addEventListener("change", this.__handleFeaturedChange);
    this.__allTab.addEventListener("change", this.__handleAllChange);
  }

  disconnectedCallback() {
    if (!this.__isInitialized) {
      return;
    }

    if (this.__featuredTab && this.__handleFeaturedChange) {
      this.__featuredTab.removeEventListener("change", this.__handleFeaturedChange);
    }

    if (this.__allTab && this.__handleAllChange) {
      this.__allTab.removeEventListener("change", this.__handleAllChange);
    }

    this.__isInitialized = false;
  }

  setActiveTab(mode) {
    const showFeatured = mode === "featured";

    this.__featuredTab.checked = showFeatured;
    this.__allTab.checked = !showFeatured;

    this.__featuredPanel.classList.toggle("featured-locations__panel--active", showFeatured);
    this.__featuredPanel.classList.toggle("featured-locations__panel--inactive", !showFeatured);
    this.__allPanel.classList.toggle("featured-locations__panel--active", !showFeatured);
    this.__allPanel.classList.toggle("featured-locations__panel--inactive", showFeatured);

    if (showFeatured) {
      this.__featuredTabBtn.classList.remove("__style-secondary");
      this.__allTabBtn.classList.add("__style-secondary");
    } else {
      this.__featuredTabBtn.classList.add("__style-secondary");
      this.__allTabBtn.classList.remove("__style-secondary");
    }
  }

  handleAllChange() {
    this.setActiveTab("all");
    this.loadMapWidget();
  }

  loadMapWidget() {
    if (this.__mapIsInitialized) {
      return;
    }

    this.__mapIsInitialized = true;
    this.__mapContainer.removeAttribute("hidden");

    if (this.__mapPlaceholder) {
      this.__mapPlaceholder.setAttribute("hidden", "");
    }

    const stockist = document.createElement("stockist-store-locator");
    stockist.setAttribute("data-stockist-widget-tag", "map_2qzpzr7q");
    stockist.style.cssText = "text-align: center; width: 100%; display: block; font-size: 20px;";
    stockist.textContent = "Hold tight while we retrieve your Makery location!";

    if (!document.getElementById(STOCKIST_WIDGET_SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = STOCKIST_WIDGET_SCRIPT_ID;
      script.src = STOCKIST_WIDGET_SRC;
      script.async = true;
      document.body.appendChild(script);
    }

    this.__mapContainer.appendChild(stockist);
  }
}

if (!customElements.get("featured-locations-section")) {
  customElements.define("featured-locations-section", FeaturedLocationsSection);
}
